import { HStack, FormatNumber, Text } from '@chakra-ui/react';
import React from 'react';

export type ProductPriceProps = {
	price: {
		amount:      number;
		discounted?: number | null;
		currency:    'THB' | 'USD';
	};
};

const ProductPrice = ({ price }: ProductPriceProps) => {
	const { amount, discounted, currency } = price;
	const hasDiscount = typeof discounted === 'number' && discounted > 0;

	return (
		<HStack alignItems={'center'}>
			<Text color={discounted ? 'red.500' : 'black'} textStyle={'h5'}>
				<FormatNumber
					currency={currency}
					currencyDisplay={'symbol'}
					style={'currency'}
					value={hasDiscount ? discounted : amount}
				/>
			</Text>
			{hasDiscount && (
				<Text textDecor={'line-through'} textStyle={'p3'}>
					<FormatNumber
						currency={currency}
						currencyDisplay={'symbol'}
						style={'currency'}
						value={amount}
					/>
				</Text>
			)}
		</HStack>
	);
};

export default ProductPrice;
